module.exports = __webpack_public_path__ + "img/GTS.9ad4026b.png";